module.exports = __webpack_public_path__ + "static/assets/50afaf2c141b742a07270a837e70e829.svg";